export const GetRequestOnLate = async function (thiss) {
  // console.log("aa", thiss.currentUser.CustomerServiceExec_);
  let tableData = [];
  // let customerServiceCode = "";
  if (
    //thisSales.currentUser.Roles.some((e) => e.Id === 19 || e.Id === 25)
    thiss.currentUser.PositionID == 52 ||
    thiss.currentUser.PositionID == 74 ||
    thiss.currentUser.PositionID == 16
  ) {
    await thiss.$http
      .get(
        `/api/serviceRequests?page=1&skipItems=0&skip=0&limit=200&status=3&companyCode=${thiss.currentCompany}&CustomerService=${thiss.currentUser.CustomerServiceExec_}`
      )
      .then((resp) => {
        // tableData = resp.data.Items;
        resp.data.Items.forEach((d) => {
          if (d.DiasRetraso > 0 && !d.CommentOnLate) {
            tableData.push(d);
          }
        });
      })

      .catch((err) => {
        thiss.$alert(err.message, err.name, {
          type: "error"
        });
      });

    return tableData;
  } else {
    return tableData;
  }
};
